import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { User, Lock, Mail, ArrowRight, ShieldCheck, Download } from 'lucide-react';
export function Registration() {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    email: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle registration logic here
    console.log('Registering:', formData);
  };
  return <section className="pt-12 pb-16 md:pt-16 md:pb-24 relative z-10 overflow-hidden" id="register" data-id="element-307">
      {/* Background Image */}
      <div className="absolute inset-0 z-0 pointer-events-none" data-id="element-308">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-80" style={{
        backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/7YNT4SQ2s7UKUJjcfWRYMN/ChatGPT_Image_Mar_26,_2026,_01_56_00_AM.png")'
      }} data-id="element-309" />
        {/* Gradients to blend with the rest of the site */}
        <div className="absolute inset-0 bg-gradient-to-b from-darkerBlue via-darkerBlue/40 to-darkerBlue" data-id="element-310" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-311">
        <div className="text-center mb-10" data-id="element-312">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 font-cinzel text-gold-light drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]" data-id="element-313">
            Comienza tu Aventura <br data-id="element-314" />
            <span className="text-gold" data-id="element-315">en MU Vanguard</span>
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-gold-light/90 font-semibold tracking-wider mb-6 text-sm md:text-base drop-shadow-[0_1px_2px_rgba(0,0,0,0.8)]" data-id="element-316">
            Season 6 Oficial • Estable • Balanceado
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-gray-200 max-w-2xl mx-auto leading-relaxed drop-shadow-[0_1px_2px_rgba(0,0,0,0.8)]" data-id="element-317">
            Adéntrate en un mundo donde cada decisión importa. Forja tu camino,
            fortalece tu personaje y sé parte de una comunidad construida para
            durar.
          </motion.p>
        </div>

        {/* Two Column Layout: Form + Character */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center max-w-5xl mx-auto" data-id="element-318">
          {/* Registration Form Container - LEFT SIDE */}
          <div data-id="element-319">
            {/* "Únete a la aventura" Text - Above Form */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2,
            duration: 0.5
          }} className="mb-5 text-center" data-id="element-320">
              <h3 className="text-2xl md:text-3xl font-bold font-cinzel text-gold-light drop-shadow-[0_2px_8px_rgba(212,175,55,0.8)]" data-id="element-321">
                Únete a la aventura
              </h3>
              <div className="w-32 h-1 bg-gradient-to-r from-transparent via-gold to-transparent mx-auto mt-2 rounded-full" data-id="element-322" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3,
            duration: 0.5
          }} className="relative" data-id="element-323">
              {/* Ornate Border Wrapper */}
              <div className="absolute inset-0 bg-gradient-to-b from-gold/40 via-gold/10 to-gold/40 rounded-sm blur-[2px]" data-id="element-324" />

              <div className="relative bg-black/80 backdrop-blur-md border border-gold/40 p-1 rounded-sm shadow-[0_0_50px_rgba(212,175,55,0.15)]" data-id="element-325">
                {/* Inner Border */}
                <div className="border border-gold/20 p-6 sm:p-8 relative" data-id="element-326">
                  {/* Top/Bottom Decorative Diamonds */}
                  <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-4 h-4 bg-gold rotate-45 shadow-[0_0_10px_rgba(212,175,55,0.8)]" data-id="element-327" />
                  <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-4 h-4 bg-gold rotate-45 shadow-[0_0_10px_rgba(212,175,55,0.8)]" data-id="element-328" />

                  <form onSubmit={handleSubmit} className="space-y-4" data-id="element-329">
                    {/* Username Input */}
                    <div className="relative group" data-id="element-330">
                      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-331">
                        <User className="h-5 w-5 text-gold/70 group-focus-within:text-gold transition-colors" data-id="element-332" />
                      </div>
                      <input type="text" placeholder="Usuario" required value={formData.username} onChange={e => setFormData({
                      ...formData,
                      username: e.target.value
                    })} className="w-full bg-black/50 border border-gold/30 rounded-sm py-3 pl-12 pr-4 text-white placeholder-gray-500 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold/50 transition-all" data-id="element-333" />
                    </div>

                    {/* Password Input */}
                    <div className="relative group" data-id="element-334">
                      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-335">
                        <Lock className="h-5 w-5 text-gold/70 group-focus-within:text-gold transition-colors" data-id="element-336" />
                      </div>
                      <input type="password" placeholder="Contraseña" required value={formData.password} onChange={e => setFormData({
                      ...formData,
                      password: e.target.value
                    })} className="w-full bg-black/50 border border-gold/30 rounded-sm py-3 pl-12 pr-4 text-white placeholder-gray-500 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold/50 transition-all" data-id="element-337" />
                    </div>

                    {/* Email Input */}
                    <div className="relative group" data-id="element-338">
                      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-339">
                        <Mail className="h-5 w-5 text-gold/70 group-focus-within:text-gold transition-colors" data-id="element-340" />
                      </div>
                      <input type="email" placeholder="Email" required value={formData.email} onChange={e => setFormData({
                      ...formData,
                      email: e.target.value
                    })} className="w-full bg-black/50 border border-gold/30 rounded-sm py-3 pl-12 pr-4 text-white placeholder-gray-500 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold/50 transition-all" data-id="element-341" />
                    </div>

                    {/* Submit Button */}
                    <button type="submit" className="w-full mt-6 bg-gradient-to-r from-[#8B6914] via-[#D4AF37] to-[#8B6914] text-black font-bold font-cinzel text-lg py-3 rounded-sm hover:shadow-[0_0_20px_rgba(212,175,55,0.4)] transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] border border-gold-light/50" data-id="element-342">
                      CREAR MI PERSONAJE
                    </button>
                  </form>

                  {/* Footer Links */}
                  <div className="mt-6 space-y-3 text-sm text-gray-400 text-center" data-id="element-343">
                    <a href="#login" className="flex items-center justify-center gap-2 hover:text-gold transition-colors group" data-id="element-344">
                      <ArrowRight className="w-4 h-4 text-gold group-hover:translate-x-1 transition-transform" data-id="element-345" />
                      Ya tienes cuenta? Iniciar sesión
                    </a>
                    <a href="#guide" className="flex items-center justify-center gap-2 hover:text-gold transition-colors group" data-id="element-346">
                      <ArrowRight className="w-4 h-4 text-gold group-hover:translate-x-1 transition-transform" data-id="element-347" />
                      Nuevo jugador? Ver Guía
                    </a>

                    <div className="pt-4 mt-4 border-t border-gold/20 flex flex-wrap items-center justify-center gap-4 text-xs" data-id="element-348">
                      <span className="flex items-center gap-1 text-gray-500" data-id="element-349">
                        <ShieldCheck className="w-4 h-4 text-gold/70" data-id="element-350" />
                        Registro seguro
                      </span>
                      <span className="hidden sm:inline text-gold/30" data-id="element-351">|</span>
                      <a href="#download" className="flex items-center gap-1 hover:text-gold transition-colors group" data-id="element-352">
                        <ArrowRight className="w-3 h-3 text-gold group-hover:translate-x-1 transition-transform" data-id="element-353" />
                        Descargar Cliente
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Elf Character Image - RIGHT SIDE */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4,
          duration: 0.5
        }} className="hidden lg:flex flex-col justify-center items-center" data-id="element-354">
            <div className="relative" data-id="element-355">
              {/* Multiple Glow Layers for Epic Effect */}
              <div className="absolute inset-0 bg-glowBlue/30 blur-[120px] rounded-full animate-pulse" data-id="element-356" />
              <div className="absolute inset-0 bg-gold/20 blur-[80px] rounded-full" data-id="element-357" />

              {/* Floating Character with Animation */}
              <motion.img src="https://cdn.magicpatterns.com/uploads/cxzDR7hnoq8BtyLXXLQWXU/ChatGPT_Image_Mar_26,_2026,_02_22_24_AM.png" alt="Elf Muse Character" className="relative z-10 w-full max-w-md h-auto object-contain drop-shadow-[0_0_50px_rgba(100,181,246,0.6)]" animate={{
              y: [0, -20, 0]
            }} transition={{
              duration: 3,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-358" />

              {/* Sparkle Effects */}
              <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-glowBlue rounded-full animate-ping" data-id="element-359" />
              <div className="absolute top-1/3 right-1/4 w-2 h-2 bg-gold rounded-full animate-ping" style={{
              animationDelay: '0.2s'
            }} data-id="element-360" />
              <div className="absolute bottom-1/3 left-1/3 w-2 h-2 bg-glowBlue rounded-full animate-ping" style={{
              animationDelay: '0.4s'
            }} data-id="element-361" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}